// AUTO-GENERATED GraphQL Builder for Customer
import * as Builders from '../';
export class CustomerBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  name(){ return this.add('name'); }
  email(){ return this.add('email'); }
  phone(){ return this.add('phone'); }
  addressLine(){ return this.add('addressLine'); }
  userId(){ return this.add('userId'); }
  status(){ return this.add('status'); }
  icNo(){ return this.add('icNo'); }
  marketingConsent(){ return this.add('marketingConsent'); }
  photoUrl(){ return this.add('photoUrl'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  user(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('user'))return this;
    this.v.add('user');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`user { ${inner} }`);
    return this;
  }

  bookingList(b?:(q:Builders.BookingBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingList'))return this;
    this.v.add('bookingList');
    const n=new Builders.BookingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingList { ${inner} }`);
    return this;
  }

  customerAccessLogList(b?:(q:Builders.CustomerAccessLogBuilder)=>void){
    if(this.depth>=5||this.v.has('customerAccessLogList'))return this;
    this.v.add('customerAccessLogList');
    const n=new Builders.CustomerAccessLogBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`customerAccessLogList { ${inner} }`);
    return this;
  }

  reviewList(b?:(q:Builders.ReviewBuilder)=>void){
    if(this.depth>=5||this.v.has('reviewList'))return this;
    this.v.add('reviewList');
    const n=new Builders.ReviewBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`reviewList { ${inner} }`);
    return this;
  }

  waitlistList(b?:(q:Builders.WaitlistBuilder)=>void){
    if(this.depth>=5||this.v.has('waitlistList'))return this;
    this.v.add('waitlistList');
    const n=new Builders.WaitlistBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`waitlistList { ${inner} }`);
    return this;
  }

  weddingCardList(b?:(q:Builders.WeddingCardBuilder)=>void){
    if(this.depth>=5||this.v.has('weddingCardList'))return this;
    this.v.add('weddingCardList');
    const n=new Builders.WeddingCardBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`weddingCardList { ${inner} }`);
    return this;
  }

  reverseBooking(b?:(q:Builders.BookingBuilder)=>void){
    const n=new Builders.BookingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingList { ${inner} }`);
    return this;
  }

  reverseCustomerAccessLog(b?:(q:Builders.CustomerAccessLogBuilder)=>void){
    const n=new Builders.CustomerAccessLogBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`customerAccessLogList { ${inner} }`);
    return this;
  }

  reverseLoginResult(b?:(q:Builders.LoginResultBuilder)=>void){
    const n=new Builders.LoginResultBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`loginResultList { ${inner} }`);
    return this;
  }

  reverseReview(b?:(q:Builders.ReviewBuilder)=>void){
    const n=new Builders.ReviewBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`reviewList { ${inner} }`);
    return this;
  }

  reverseWaitlist(b?:(q:Builders.WaitlistBuilder)=>void){
    const n=new Builders.WaitlistBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`waitlistList { ${inner} }`);
    return this;
  }

  reverseWeddingCard(b?:(q:Builders.WeddingCardBuilder)=>void){
    const n=new Builders.WeddingCardBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`weddingCardList { ${inner} }`);
    return this;
  }
}
